import React, { useEffect } from 'react';
import {Routes, Route } from 'react-router-dom';
import PWAInstallPrompt from './components/UI/PWAInstallPrompt';
import PWANotificationPrompt from './components/UI/PWANotificationPrompt';
import Home from './components/Home/Home';
import NotFound from './components/Home/NotFound';
import UnderConstruction from './components/Home/UnderConstruction';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Verification from './components/Auth/Verification';
import PwdRecovery from './components/Auth/PwdRecovery';
import Resume from './components/Resume/Resume'
import BizProposal from './components/BizProposal/BizProposal';
import ResumeLearnMore from './components/UI/LearnMorePages/ResumeLearnMore';
import ViewResume from './components/Resume/ViewResume'
import Depositions from './components/Depositions/Depositions';
import MockTests from './components/MockTests/MockTests';
import Pricing from './components/Pricing/Pricing';
import TransactionDone from './components/TransactionDone/TransactionDone';
import Profile from './components/Dashboard/Profile';
import DashSupport from './components/Dashboard/DashSupport';
import NotificationsPage from './components/Dashboard/Notifications';
import ResumeHub from './components/Resume/Items/ResumeHub';
import JobHub from './components/Resume/Items/JobHub';
import CompletedApplications from './components/Resume/Items/CompletedApplications.jsx';
import ReferralHub from './components/Resume/Items/ReferralHub';
import RecruiterHub from './components/Resume/Items/RecruiterHub';
import Courses from './components/Courses/Courses';
import CareerRoadmap from './components/Career/CareerRoadmap';
// Removed unused exam imports
import Ican from "./components/MockTests/Exams/Ican/Ican";
import Utme from "./components/MockTests/Exams/Utme/Utme";
import Wassce from "./components/MockTests/Exams/Wassce";
import Ncs from './components/MockTests/Exams/Ncs/Ncs';
import Nscdc from './components/MockTests/Exams/Nscdc/Nscdc';
import Trcn from './components/MockTests/Exams/Trcn/Trcn';
import Fcsc from './components/MockTests/Exams/Fcsc/Fcsc';
import Nis from './components/MockTests/Exams/Nis/Nis';
import Ffs from './components/MockTests/Exams/Ffs/Ffs';
import Subeb from './components/MockTests/Exams/Subeb/Subeb';
import ExamStarted from "./components/MockTests/ExamStarted/ExamStarted"
import InsightNTutor from "./components/MockTests/InsightNTutor/InsightNTutor"
import SimulatedExams from './components/MockTests/SimulatedExams/SimulatedExams'
import ExamPricing from './components/Pricing/ExamPricing';
// End removed imports
import ResetPass from './components/Dashboard/ResetPass';
import GoogleCallback from './components/Auth/GoogleCallback';
import Terms from './components/Home/Terms';
// import HowIWork from './components/Home/HowIWork';
import ContactUsPage from './components/Home/ContactUsPage';
import AdminLogin from './origin-components/AdminLogin';
import SchoolLogin from './components/School/SchoolLogin';
import SchoolAdminDashboard from './components/School/SchoolAdminDashboard';
import TeacherDashboard from './components/School/TeacherDashboard';
import StudentDashboard from './components/School/StudentDashboard';
import ParentDashboard from './components/School/ParentDashboard';
import AdminsDashboard from './origin-components/AdminsDashboard';
import AnalyticsDashboard from './origin-components/AnalyticsDashboard';
import CouponDashboard from './origin-components/CouponDashboard';
import UsersDashboard from './origin-components/UsersDashboard';
import TransactionsDashboard from './origin-components/TransactionsDashboard';
import ReferralDashboard from './origin-components/ReferralDashboard';
import TestimonialsDashboard from './origin-components/TestimonialsDashboard';
import AntiAbuseLinkages from './origin-components/AntiAbuseLinkages';
import SchoolsDashboard from './origin-components/SchoolsDashboard';
import EmailSubscriptionsDashboard from './origin-components/EmailSubscriptionsDashboard';
import UnsubscribePage from './components/Email/UnsubscribePage';
import EmailPreferencesPage from './components/Email/EmailPreferencesPage';
import AskMe from "./components/Home/AskMe"
import GlobalChatWidget from './components/UI/GlobalChatWidget';
import DownloadCoverLetter from './components/Resume/CoverLetters/DownloadCoverLetter';
import { ConfirmProvider } from "material-ui-confirm";
import { useSelector } from "react-redux";
import { Fetching } from './components/UI/Modal/Modal';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GlobalStyle from "./styled/GlobalStyles";
import HowIWork from "./components/UI/Learn/HowIWork";
import Alert from "./components/UI/Alerts/Alert";


//Wrap whole app around ConfirmProvider to be able to open confirmation dialog prompt


const App = () => {
  const { fetching, error, info, success } = useSelector(state => state.stateData)
  const [pricingOpen, setPricingOpen] = React.useState(false);

  // Load PWA-specific scripts
  useEffect(() => {
    const handler = () => {
        setPricingOpen(true);
    };
    window.addEventListener('openExamPricing', handler);
    return () => window.removeEventListener('openExamPricing', handler);
  }, []);

  useEffect(() => {
    // Load iOS fixes
    const iosFixes = document.createElement('script');
    iosFixes.src = '/ios-fixes.js';
    iosFixes.async = true;
    document.body.appendChild(iosFixes);

    // Load iOS CSS fixes
    const iosFixesCSS = document.createElement('link');
    iosFixesCSS.rel = 'stylesheet';
    iosFixesCSS.href = '/ios-fixes.css';
    document.head.appendChild(iosFixesCSS);

    // Load network detector
    const networkDetector = document.createElement('script');
    networkDetector.src = '/network-detector.js';
    networkDetector.async = true;
    document.body.appendChild(networkDetector);

    // Load performance fixes
    const performanceFixes = document.createElement('script');
    performanceFixes.src = '/performance-fixes.js';
    performanceFixes.async = true;
    document.body.appendChild(performanceFixes);

    // Clean up on unmount
    return () => {
      document.body.removeChild(iosFixes);
      document.head.removeChild(iosFixesCSS);
      document.body.removeChild(networkDetector);
      document.body.removeChild(performanceFixes);
    };
  }, []);

  return (
      <>
        <GlobalStyle />
        <div className="alerts">
          <Alert error={error}/>
          <Alert info={info}/>
          <Alert success={success}/>
        </div>
        <GoogleOAuthProvider clientId="260080247067-o0iar4akf4pce1j5ilstvkdeb9tr3elm.apps.googleusercontent.com">
          <ConfirmProvider>
            <Routes>
              <Route path={'/auth/google/callback'} element={ <GoogleCallback /> } />
              <Route path={'/user/dashboard/mock/acca'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/cee'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/ceh'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/cfa'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/cima'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/cissp'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/frm'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/gre'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/ielts'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/neco'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/pmp'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/toefl'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/mock/ican'} element={ <Ican /> } />
              <Route path={'/user/dashboard/mock/ncs'} element={ <Ncs /> } />
              <Route path={'/user/dashboard/mock/subeb'} element={ <Subeb /> } />
              <Route path={'/user/dashboard/mock/nscdc'} element={ <Nscdc /> } />
              <Route path={'/user/dashboard/mock/trcn'} element={ <Trcn /> } />
              <Route path={'/user/dashboard/mock/fcsc'} element={ <Fcsc /> } />
              <Route path={'/user/dashboard/mock/ffs'} element={ <Ffs /> } />
              <Route path={'/user/dashboard/mock/nis'} element={ <Nis /> } />
              <Route path={'/user/dashboard/mock/utme'} element={ <Utme /> } />
              <Route path={'/user/dashboard/mock/exam-started'} element={ <ExamStarted /> } />
              <Route path={'/user/dashboard/mock/exam-insight'} element={ <InsightNTutor /> } />
              <Route path={'/user/dashboard/mock/written'} element={ <SimulatedExams /> } />

              <Route path={'/user/dashboard/mock/wassce'} element={ <Wassce /> } />
              <Route path={'/user/dashboard/profile'} element={ <Profile /> } />
              <Route path={'/user/dashboard/dash-support'} element={ <DashSupport /> } />
              <Route path={'/user/dashboard/notifications'} element={ <NotificationsPage /> } />
              <Route path={'/user/dashboard/reset-pass'} element={ <ResetPass /> } />
              <Route path={'/user/dashboard/resume-hub'} element={ <ResumeHub /> } />
              <Route path={'/user/dashboard/job-hub'} element={ <JobHub /> } />
              <Route path={'/user/dashboard/auto-apply'} element={ <CompletedApplications /> } />
              <Route path={'/user/dashboard/referral-hub'} element={ <ReferralHub /> } />
              <Route path={'/user/dashboard/recruiter'} element={ <RecruiterHub /> } />
              <Route path={'/user/dashboard/courses'} element={ <Courses /> } />
              <Route path={'/user/dashboard/career-roadmap'} element={ <CareerRoadmap /> } />
              <Route path={'/user/dashboard/resume'} element={ <Resume /> }/>
              <Route path={'/user/dashboard/depositions'} element={ <Depositions /> } />
              <Route path={'/user/dashboard/mock'} element={ <MockTests /> } />
              <Route path={'/user/dashboard/business-plan'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/business-proposal'} element={ <BizProposal /> } />
              <Route path={'/user/dashboard/product-price'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/councellor'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/fraud-detector'} element={ <UnderConstruction /> } />
              <Route path={'/user/dashboard/generate-report'} element={ <UnderConstruction /> } />
              <Route path={'/learn-more'} element={<ResumeLearnMore />} />
              <Route path={'/view-resume'} element={<ViewResume />} />
              <Route path={'/popin'} element={ <Login /> } />
              <Route path={'/verify'} element={ <Verification /> } />
              <Route path={'/reset-password'} element={ <PwdRecovery /> } />
              <Route path={'/join-bubble'} element={<Register />} />
              <Route path={'/pricing'} element={<Pricing />} />
              <Route path={'/privacy'} element={<Terms />} />
              <Route path={'/how-i-work'} element={<ResumeLearnMore />}>
                <Route path={':feature'} element={<HowIWork/>}/>
              </Route>
              <Route path={'/support'} element={<ContactUsPage />} />
              <Route path={'/transaction'} element={<TransactionDone />} />
              <Route path={'/chat'} element={<AskMe />} />
              <Route path={'/cover-letter'} element={<DownloadCoverLetter />} />
              <Route path="/not-found" element={<NotFound />} />
              <Route path={'/school'} element={<SchoolLogin />} />
              <Route path={'/schools'} element={<SchoolLogin />} />
              <Route path={'/school/admin/dashboard'} element={<SchoolAdminDashboard />} />
              <Route path={'/school/teacher/dashboard'} element={<TeacherDashboard />} />
              <Route path={'/school/student/dashboard'} element={<StudentDashboard />} />
              <Route path={'/school/parent/dashboard'} element={<ParentDashboard />} />
              <Route path={'/origin/consent'} element={<AdminLogin />} />
              <Route path={'/origin/dashboard/admins'} element={<AdminsDashboard />} />
              <Route path={'/origin/dashboard/analytics'} element={<AnalyticsDashboard />} />
              <Route path={'/origin/dashboard/anti-abuse'} element={<AntiAbuseLinkages />} />
              <Route path={'/origin/dashboard/coupons'} element={<CouponDashboard />} />
              <Route path={'/origin/dashboard/users'} element={<UsersDashboard />} />
              <Route path={'/origin/dashboard/transactions'} element={<TransactionsDashboard />} />
              <Route path={'/origin/dashboard/referrals'} element={<ReferralDashboard />} />
              <Route path={'/origin/dashboard/testimonials'} element={<TestimonialsDashboard />} />
              <Route path={'/origin/dashboard/schools'} element={<SchoolsDashboard />} />
              <Route path={'/origin/dashboard/email-subscriptions'} element={<EmailSubscriptionsDashboard />} />
              <Route path={'/unsubscribe'} element={<UnsubscribePage />} />
              <Route path={'/email-preferences'} element={<EmailPreferencesPage />} />
              <Route exact path={'/'} element={<Home />} />
              <Route path="*" element={<NotFound />} />
            </Routes>

            {fetching && <Fetching />}
            <GlobalChatWidget />
          </ConfirmProvider>

          {/* PWA Components */}
          <PWAInstallPrompt />
          <PWANotificationPrompt />
          <ExamPricing open={pricingOpen} closePricing={() => setPricingOpen(false)} />
        </GoogleOAuthProvider>

      </>

  );
}

export default App;
